var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModelteamLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 4.18536L3.12268 27.3556H29.8773L16.5 4.18536ZM16.5 11.2066L9.20329 23.8449H23.7967L16.5 11.2066Z",
    fill: "#61646C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelteamLogo);
export default __webpack_public_path__ + "static/media/modelteam-logo.eb16cacb36ef0072ce69cf8fe77a6f0a.svg";
export { ForwardRef as ReactComponent };